// extracted by mini-css-extract-plugin
export default {"historyButtonsContainer":"HistoryButtons_historyButtonsContainer__K993H","fadeInUp":"HistoryButtons_fadeInUp__xL1ab","historyButton":"HistoryButtons_historyButton__cmS78"};